import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { Outlet } from 'react-router-dom';
import auth, { hasAcr } from '../../../utils/auth';
import AppError from './AppError';

function ProtectedRoute() {
  const { getText } = useTranslations();

  if (!auth.authenticated) {
    auth.login();
    return null;
  }

  if (!hasAcr(3)) {
    return (
      <AppError
        title={getText('keycloak.acrStepUp.title')}
        description={getText('keycloak.acrStepUp.message')}
        action={{
          label: 'Gå til innlogging',
          onAction: () => auth.login()
        }}
      />
    );
  }

  return <Outlet />;
}

export default ProtectedRoute;
